import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import SuspenseFallback from 'components/routers/RouteHandler/SuspenseFallback';
import { roles } from 'utility/constants/roles';

const LoadBalancersLayout = lazy(
	() => import('pages/services/LoadBalancersContainer'),
);

const CloudLoadBalancer = lazy(
	() =>
		import(
			'pages/services/LoadBalancersContainer/LoadBalancers/CloudLoadBalancer'
		),
);
const DedicatedLoadBalancer = lazy(
	() =>
		import('pages/services/LoadBalancersContainer/LoadBalancers/LoadBalancers'),
);

const DedicatedLoadBalancerConfig = lazy(
	() => import('pages/services/DedicatedLoadBalancerConfig'),
);
const CloudLoadBalancerConfig = lazy(
	() => import('pages/services/CloudLoadBalancerConfig'),
);

const CloudLoadBalancerNodes = lazy(
	() =>
		import(
			'pages/services/CloudLoadBalancerConfig/Nodes/CloudLoadBalancerNodes'
		),
);
const CloudLoadBalancerSettings = lazy(
	() =>
		import(
			'pages/services/CloudLoadBalancerConfig/Settings/CloudLoadBalancerSettings'
		),
);
const CloudLoadBalancerAdvanced = lazy(
	() =>
		import(
			'pages/services/CloudLoadBalancerConfig/Settings/Advanced/CloudLoadBalancerAdvanced'
		),
);
const CloudLoadBalancerGeneral = lazy(
	() =>
		import(
			'pages/services/CloudLoadBalancerConfig/Settings/General/CloudLoadBalancerGeneral'
		),
);
const LoadBalancerRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/services/load-balancers/dedicated/:uniqId"
				component={DedicatedLoadBalancerConfig}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route path="/services/load-balancers/cloud/:uniqId">
				<CloudLoadBalancerConfig>
					<Suspense fallback={<SuspenseFallback />}>
						<Switch>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers/cloud/:uniqId/nodes"
								component={CloudLoadBalancerNodes}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
							<Route path="/services/load-balancers/cloud/:uniqId/settings/:type">
								<CloudLoadBalancerSettings>
									<Suspense fallback={<SuspenseFallback />}>
										<Switch>
											<RoleRestrictedRoute
												path="/services/load-balancers/cloud/:uniqId/settings/advanced"
												component={CloudLoadBalancerAdvanced}
												whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
											/>
											<RoleRestrictedRoute
												path="/services/load-balancers/cloud/:uniqId/settings/general"
												component={CloudLoadBalancerGeneral}
												whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
											/>
										</Switch>
									</Suspense>
								</CloudLoadBalancerSettings>
							</Route>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers/cloud/:uniqId/settings"
								component={CloudLoadBalancerSettings}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers/cloud/:uniqId"
								component={CloudLoadBalancerNodes}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
						</Switch>
					</Suspense>
				</CloudLoadBalancerConfig>
			</Route>
			<Route path="/services/load-balancers">
				<LoadBalancersLayout>
					<Suspense fallback={<SuspenseFallback />}>
						<Switch>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers/cloud"
								component={CloudLoadBalancer}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers/dedicated"
								component={DedicatedLoadBalancer}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
							<RoleRestrictedRoute
								exact
								path="/services/load-balancers"
								component={CloudLoadBalancer}
								whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
							/>
						</Switch>
					</Suspense>
				</LoadBalancersLayout>
			</Route>
			{/* Backwards compatibility for older routes that didn't include server type */}
			<RoleRestrictedRoute
				exact
				path="/services/load-balancers/:uniqId"
				component={({ match }) => (
					<Redirect
						to={`/services/load-balancers/cloud/${match.params.uniqId}`}
					/>
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
		</Switch>
	);
};

export default LoadBalancerRouter;
